import { ApolloClient, createHttpLink, InMemoryCache } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";
import { RetryLink } from "@apollo/client/link/retry";
import { relayStylePagination } from "@apollo/client/utilities";
import { shopifyPagination } from "@src/graphql/util/shopifyPagination";

import { getAuthToken } from "../utils";

const httpLink = createHttpLink({
  uri: `${
    import.meta.env.VITE_GRAPHQL_URL || import.meta.env.VITE_BASE_URL
  }/v2/shopify/graphql`,
});

// Log any GraphQL errors or network error that occurred
const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors)
    graphQLErrors.forEach(({ message, locations, path }) =>
      console.log(
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions,@typescript-eslint/no-base-to-string
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
      )
    );
  if (networkError) console.log(`[Network error]: ${networkError}`);
});

const authLink = setContext((_, { headers }) => {
  return {
    headers: {
      ...headers,
      Authorization: getAuthToken(),
    },
  };
});

const retryLink = new RetryLink({
  delay: {
    initial: 300,
    max: Infinity,
    jitter: true,
  },
  attempts: {
    max: 5,
    retryIf: (error, _operation) => !!error,
  },
});

export const shopifyGqlClient = new ApolloClient({
  devtools: {
    enabled: true,
  },
  link: authLink.concat(retryLink).concat(errorLink).concat(httpLink),
  cache: new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          products: shopifyPagination(),
          productTypes: shopifyPagination(),
          productTags: shopifyPagination(),
          productVendors: shopifyPagination(),
          deliveryProfiles: relayStylePagination(),
          collections: relayStylePagination(),
        },
      },
      Product: {
        fields: {
          variants: relayStylePagination(),
        },
      },
    },
  }),
});
